import React from 'react';
import {Link} from 'react-router-dom'


function Find() {
  return (
    <div className="find-area">
    <div className="container custom-container">
      <div className="row">
        <div className="col-12">
          <form >
            <div className="find-wrap">
              <div className="location">
                <i className="flaticon-location" />
                <input type="text" defaultValue="Dagga - Kholpa Site Tangis" />
              </div>
              <div className="find-category">
                <ul>
                  <li><Link to="#"><i className="flaticon-dog" /> Trouvez votre chien</Link></li>
                  <li><Link to="#"><i className="flaticon-happy" /> Chez</Link></li>
                  <li><Link to="#"><i className="flaticon-dove" /> SafiDog</Link></li>
                </ul>
              </div>
              <div className="other-find">
                <div className="dropdown">
                  <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    76 808 09 15
                  </button>
                  <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <Link className="dropdown-item" to="#">Trouvez votre chien</Link>
                    <Link className="dropdown-item" to="#">Chez</Link>
                    <Link className="dropdown-item" to="#">SafiDog</Link>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  )
}

export default Find;
